import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';

const { createUniqueId } = common;
const dialogId = createUniqueId();
const dialogContentId = createUniqueId();

let dialogBoxDom = null;
// let dialogContentBox = null;

const showDialog = () => {
    dom.$id(dialogId).style.display = 'flex';
};

const hideDialog = () => {
    dom.$id(dialogId).style.display = 'none';
};

const Dialog = (props = {}) => {
    const { contentComponent, isRightClose = false, onClose } = props;

    const data = {
        dialogId,
        dialogContentId,
        isRightClose,
        contentComponent,
    };

    const events = {
        close: () => {
            hideDialog();
            onClose && onClose();
        },
    };
    // 每次调用Dialog时，重新执行createComponent来更新对话框的内容和事件绑定
    // 这样可以确保使用最新的props，包括最新的onClose回调
    const component = createComponent(tpl, { data, style }, events);
    if (dialogBoxDom) {
        // 如果对话框已经存在，则先移除旧的对话框
        document.body.removeChild(dialogBoxDom);
    }
    // 将新的对话框添加到文档中
    document.body.insertAdjacentHTML('afterbegin', component);
    dialogBoxDom = dom.$id(dialogId);

    // if (!dialogBox) {
    //     const component = createComponent(tpl, { data, style }, events);
    //     document.body.insertAdjacentHTML('afterbegin', component);
    //     dialogBox = dom.$id(dialogId);
    //     dialogContentBox = dom.$id(dialogContentId);
    // } else {
    //     dialogContentBox.innerHTML = contentComponent;
    //     dialogBox.style.cssText = 'display:flex';
    // }
};

export default Dialog;
export { showDialog, hideDialog };
